import BasicModal from '../../../components/modals/BasicModal';
import { useState } from 'react';
import { useCollections } from '../Contexts/CollectionsContext';
import { FolderPlusIcon } from '@heroicons/react/24/outline';
import { Mixpanel } from '../../../services/Mixpanel';
export const CreateOrRenameCollectionModal = ({
  onClose,
  onRename,
  onCreate,
  collection,
  packet,
  source = 'unknown',
}) => {
  const noun = 'Folder';
  const [collectionName, setCollectionName] = useState(collection?.title || '');
  const [collectionDescription, setCollectionDescription] = useState(collection?.description || '');
  const { createCollection, updateCollectionName } = useCollections();
  const onSubmit = async () => {
    const description = collectionDescription.trim();
    if (collection) {
      Mixpanel.track('Collection Renamed', {
        collection_id: collection.id,
        collection_title: collection.title,
        new_collection_title: collectionName,
      });
      await updateCollectionName({
        collectionId: collection.id,
        title: collectionName,
        description,
      });
      onRename?.(collection.id, collectionName);
    } else {
      const newCollection = await createCollection({
        title: collectionName,
        description,
        packet_id: packet ? packet.id : null,
      });
      Mixpanel.track('Shared Folder Created', {
        folder_id: newCollection.id,
        source,
        folder_title: newCollection.title,
      });
      onCreate?.(newCollection);
    }
    onClose();
  };
  return (
    <div>
      <BasicModal showModal={true} setShowModal={onClose}>
        <div className='flex flex-col gap-y-6 items-center'>
          <div className='text-lg font-medium text-center flex flex-col items-center'>
            <p>
              {collection ? 'Rename' : 'Create'} {noun}
            </p>
            <p className='text-sm text-gray-500 max-w-[80%]'>
              {!collection && !packet && (
                <span className=''>
                  You can add resources to this {noun.toLowerCase()} by clicking the folder{' '}
                  <FolderPlusIcon
                    aria-label='Folder'
                    className='w-3.5 h-3.5 inline-block align-middle'
                  />{' '}
                  icon
                </span>
              )}
            </p>
          </div>

          <input
            type='text'
            autoFocus
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onSubmit();
              }
            }}
            value={collectionName}
            onChange={(e) => setCollectionName(e.target.value)}
            className='mt-1 w-[90%] px-3 py-3 text-md text-gray-900 placeholder-gray-500 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-emerald-500 focus:border-emerald-500'
            placeholder={`Enter a ${noun.toLowerCase()} name`}
          />
          <textarea
            rows={3}
            value={collectionDescription}
            onChange={(e) => setCollectionDescription(e.target.value)}
            className='w-[90%] px-3 py-2 text-md text-gray-900 placeholder-gray-500 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 resize-none'
            placeholder='Add a short description so people know what this folder is for (optional)'
          />
          <button
            onClick={onSubmit}
            className='bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-3 rounded-md disabled:bg-emerald-500 disabled:text-gray-50'>
            {collection ? 'Rename' : 'Create'} {noun}
          </button>
        </div>
      </BasicModal>
    </div>
  );
};
